import { MODAL_TYPE_POST_EDITOR } from '@wix/communities-blog-client-common/dist/src/constants/modal-types';
import { closeModal } from '../modals/framework/store/modal-actions';
import { getPost } from '../selectors/post-selectors';
import { isEditor } from '../selectors/view-mode-selectors';
import { updatePost } from './update-post';
import { navigateWithinPostPage, navigateWithinBlog } from './navigate-within-blog';

const handleDiscardSuccess = post => (dispatch, getState) => {
  const state = getState();
  if (isEditor(state)) {
    dispatch(navigateWithinBlog('/'));
  } else {
    dispatch(navigateWithinPostPage(`/${post.slug}`));
  }
  dispatch(closeModal({ type: MODAL_TYPE_POST_EDITOR }));
};

export const discardPostDraft = postId => (dispatch, getState) => {
  dispatch(updatePost(getPost(getState(), postId))).then(post => dispatch(handleDiscardSuccess(post)));
};
